/**
 * Created by: Lior Elrom
 * Date: 5/6/15
 * Time: 4:19 PM
 */

'use strict';

var $ = require('dibs-jquery-shim');
var _ = require('underscore');

var defaultDelay = 0;        // Default value for how long the delay will last
var defaultDuration = 'slow';  // Default value for how long the animation will run

var scrollHelper = module.exports = {
    /**
     * Get the absolute position of the scroll from the top of the screen
     * @returns {Number}
     */
    getWindowScroll: function () {
        return $(window).scrollTop();
    },

    /**
     * Get the position of the scroll from the top of the screen plus the header's height (returns the scroll of the bottom of the header)
     * @returns {Number}
     */
    getScrollTopOfPage: function () {
        return scrollHelper.getWindowScroll() + scrollHelper.headerHeight();
    },

    /**
     * Get the position of the scroll at the bottom of the screen
     * @returns {Number}
     */
    getScrollBottomOfPage: function () {
        return scrollHelper.getWindowScroll() + $(window).height();
    },

    /**
     * Get the element's top position of the scroll from the top of the page (without the header)
     * @param {jQuery} [$el] - the jQuery element
     * @returns {Number|null} the top position of the element
     */
    getScrollTop: function ($el) {
        if (!($el instanceof $)) {
            return null;
        }
        return $el.offset().top - scrollHelper.headerHeight();
    },

    /**
     * Get the element's bottom position of the scroll from the top of the page (without the header)
     * @param {jQuery} [$el] - the jQuery element
     * @returns {Number|null} - the bottom position of the element
     */
    getScrollBottom: function ($el) {
        if (!($el instanceof $)) {
            return null;
        }
        return scrollHelper.getScrollTop($el) + scrollHelper.getHeight($el);
    },

    /**
     * Get the jQuery element height (includes padding, border and optionally margin)
     * @param {jQuery} [$el] - the jQuery element
     * @param includeMargin {Boolean} element's height includes margin as well (default: false)
     * @returns {Number|null} - the element's height in pixels
     */
    getHeight: function ($el, includeMargin) {
        if (!($el instanceof $)) {
            return null;
        }
        includeMargin = !!includeMargin;
        return $el.outerHeight(includeMargin);
    },

    /**
     * Get the window height
     * @returns {Number} - the window height
     */
    windowHeight: function () {
        return $(window).height();
    },

    /**
     * Get the page height (deducting the header's height)
     * @returns {Number} - the page height
     */
    pageHeight: function () {
        return scrollHelper.windowHeight() - scrollHelper.headerHeight();
    },

    /**
     * Get the header height (header height might change when in different responsive view)
     * @returns {Number} - the header height
     */
    headerHeight: function () {
        return $('#header').height() || 0;
    },

    /**
     * Scroll to a specific position in the page
     * @param {Number} position - number in pixels
     * @param {Number} delay - number of milliseconds before scroll (default: 500)
     * @param {Number} duration - number of milliseconds of scroll (default: slow)
     */
    scrollTo: function (position, delay, duration) {
        position = position || 0;
        delay = _.isUndefined(delay) ? defaultDelay : delay;
        duration = _.isUndefined(duration) ? defaultDuration : duration;

        window.clearTimeout(scrollHelper.scrollTimeout);

        scrollHelper.scrollTimeout = window.setTimeout(function () {
            $('html, body').animate({ scrollTop: position }, duration);
        }, delay);
    },

    /**
     * Check if a position is above the top pf the page (behind the header or above it)
     * @param topPosition - number in pixel
     * @returns {boolean}
     */
    hasExceededTop: function (topPosition) {
        return topPosition < scrollHelper.getScrollTopOfPage();
    },

    /**
     * Check if a position is below the bottom of the page
     * @param bottomPosition - number in pixel
     * @returns {boolean}
     */
    hasExceededBottom: function (bottomPosition) {
        return bottomPosition > scrollHelper.getScrollBottomOfPage();
    },

    /**
     * Check if the top of an element is above the page (behind the header or above it)
     * @param $el - a jQuery object
     * @param offset - number of pixels from the top of an element (default: 0)
     * @returns {boolean}
     */
    isTopOfElOffTopOfScreen: function ($el, offset) {
        var topPosition = scrollHelper.getScrollTop($el) + (offset || 0);
        return scrollHelper.hasExceededTop(topPosition);
    },

    /**
     * Check if the bottom of an element is below the page
     * @param $el - a jQuery object
     * @param offset - number of pixels from the bottom of an element (default: 0)
     * @returns {boolean}
     */
    isBottomOfElOffBottomOfScreen: function ($el, offset) {
        var bottomPosition = scrollHelper.getScrollBottom($el) + (offset || 0);
        return scrollHelper.hasExceededBottom(bottomPosition);
    },

    /**
     * Check if the top of an element is below the page
     * @param $el - a jQuery object
     * @param offset - number of pixels from the top of an element (default: 0)
     * @returns {boolean}
     */
    isTopOfElOffBottomOfScreen: function ($el, offset) {
        var topPosition = scrollHelper.getScrollTop($el) + (offset || 0);
        return scrollHelper.hasExceededBottom(topPosition);
    },

    /**
     * Check if the bottom of an element is above the page (behind the header or above it)
     * @param $el - a jQuery object
     * @param offset - number of pixels from the bottom of an element (default: 0)
     * @returns {boolean}
     */
    isBottomOfElOffTopOfScreen: function ($el, offset) {
        var bottomPosition = scrollHelper.getScrollBottom($el) + offset;
        return scrollHelper.hasExceededTop(bottomPosition);
    },

    /**
     * Check if an element is completely outside of the page (above or below the page)
     * @param $el - a jQuery object
     * @param offsetTop - number of pixels from the top of an element (default: 0)
     * @param offsetBottom - number of pixels from the bottom of an element (default: 0)
     * @returns {boolean}
     */
    isCompletelyOffScreen: function ($el, offsetTop, offsetBottom) {
        offsetTop    = offsetTop    || 0;
        offsetBottom = offsetBottom || 0;
        return scrollHelper.isTopOfElOffBottomOfScreen($el, offsetTop) || scrollHelper.isBottomOfElOffTopOfScreen($el, offsetBottom);
    },

    /**
     * Check if an element is partially off of the page
     * @param $el - a jQuery object
     * @param offsetTop - number of pixels from the top of an element (default: 0)
     * @param offsetBottom - number of pixels from the bottom of an element (default: 0)
     * @returns {boolean}
     */
    isPartiallyOffScreen: function ($el, offsetTop, offsetBottom) {
        offsetTop    = offsetTop    || 0;
        offsetBottom = offsetBottom || 0;
        return scrollHelper.isTopOfElOffTopOfScreen($el, offsetTop) || scrollHelper.isBottomOfElOffBottomOfScreen($el, offsetBottom);
    },

    /**
     * Scroll element to the top of the page (up to the begging of the header)
     * @param $el - a jQuery object
     * @param offset - number of pixels from the top of an element (default: 0)
     * @param {Number} delay - number of milliseconds before scroll (default: 500)
     * @param {Number} duration - number of milliseconds of scroll (default: slow)
     */
    scrollElToTop: function ($el, offset, delay, duration) {
        var position;
        offset = offset || 0;
        position = scrollHelper.getScrollTop($el) + offset;
        scrollHelper.scrollTo(position, delay, duration);
    },

    /**
     * Scroll element to the bottom of the page (where the element's bottom reached the bottom of the page)
     * @param $el - a jQuery object
     * @param offset - number of pixels from the bottom of an element (default: 0)
     * @param {Number} delay - number of milliseconds before scroll (default: 500)
     * @param {Number} duration - number of milliseconds of scroll (default: slow)
     */
    scrollElToBottom: function ($el, offset, delay, duration) {
        var position;
        offset = offset || 0;
        position = scrollHelper.getScrollBottom($el) + offset - scrollHelper.pageHeight();
        scrollHelper.scrollTo(position, delay, duration);
    },

    /**
     * Get scroll position in percentage
     * @returns {Number} - scroll position percent
     */
    getScrollPercent: function () {
        var scrollTop = scrollHelper.getWindowScroll();
        var docHeight = $(document).height();
        var winHeight = scrollHelper.windowHeight();

        return Math.round(scrollTop / (docHeight - winHeight) * 100);
    }

};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/utils/commonjs/scrollHelper.js
// module id = 551
// module chunks = 4 7 12 13 36